module.exports = __webpack_public_path__ + "static/media/empty-box.b6ebb9cc.svg";